import gql from "graphql-tag";

export default gql`
	query Scopes {
		Scopes {
			id
			identity
			nice_name
			parent_id
			description
			group
			children {
				id
				identity
				nice_name
				parent_id
				description
				group
			}
		}
	}
`;
